import React, { createContext, useContext, useState } from "react";

interface ClassificationContextProps {
  allClassifications: any[];
  isClassificationsLoading: boolean;
  setAllClassifications: React.Dispatch<React.SetStateAction<any[]>>;
  setIsClassificationsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  reasonsCache: Record<number, any[]>;
  setReasonsCache: React.Dispatch<React.SetStateAction<Record<number, any[]>>>;
}

const ClassificationContext = createContext<ClassificationContextProps>({
  allClassifications: [],
  isClassificationsLoading: false,
  setAllClassifications: () => {},
  setIsClassificationsLoading: () => {},
  reasonsCache: {},
  setReasonsCache: () => {},
});

interface ClassificationProviderProps {
  children: React.ReactNode;
}

export const ClassificationProvider: React.FC<ClassificationProviderProps> = ({
  children,
}) => {
  const [allClassifications, setAllClassifications] = useState<any[]>([]);
  const [isClassificationsLoading, setIsClassificationsLoading] =
    useState(false);
  const [reasonsCache, setReasonsCache] = useState<Record<number, any[]>>({});

  return (
    <ClassificationContext.Provider
      value={{
        allClassifications,
        isClassificationsLoading,
        setAllClassifications,
        setIsClassificationsLoading,
        reasonsCache,
        setReasonsCache,
      }}
    >
      {children}
    </ClassificationContext.Provider>
  );
};

export const useClassificationContext = (): ClassificationContextProps => {
  return useContext(ClassificationContext);
};
